export default __webpack_public_path__ + "static/media/undraw_Hello_re_3evm.0d10963e.svg";